const style = (node, prop) => getComputedStyle(node, null).getPropertyValue(prop)

const getScrollingContainer = node => {
  const regex = /(auto|scroll)/
  if (node) {
    const overflowStyleString =
      style(node, 'overflow') + style(node, 'overflow-y') + style(node, 'overflow-x')
    const scrollable = regex.test(overflowStyleString) && node.scrollHeight > node.offsetHeight
    return scrollable ? node : getScrollingContainer(node.parentElement)
  } else return null
}

export default getScrollingContainer
